import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import {injectIntl} from "react-intl";

import * as calendarActions from './../../../actions/A_Calendar'
import * as Misc from './../../../misc';
import template from '../../../templates/PageLayout/Popups/ScheduleEntry.Popup.rt';
import * as popupActions from './../../../actions/A_Popups';
import * as Helpers from './../../../utilities/helpers';
import {AccessRights} from '../../../schemas/accessRightsModel';
import * as Enums from './../../../utilities/enums';
import {getDatePart} from "../../../utilities";
import {QUOTE_MAX_DOCUMENT_SIZE, QUOTE_MAX_NOTE_LENGTH, QUOTE_DOCUMENT_TYPES} from "../../../utilities/constants";
import {formatFileSize} from "../../../utilities/helpers";
import {validateFileExtension} from "../../../utilities/helpers";
import misc from './../../../misc';
import {getEnglishLeadType} from "../../../utilities/job";

const timeRegex = /^(\d{0,2})(:?)(\d{0,2})$/;
const durations = [
  {text: "jobBoard.appointment.durations.30m", minutes: 30},
  {text: "jobBoard.appointment.durations.1h", minutes: 60},
  {text: "jobBoard.appointment.durations.2h", minutes: 120},
  {text: "jobBoard.appointment.durations.4h", minutes: 240}
];
const alerts = [
  {text: "jobBoard.appointment.durations.15m", minutes: 15},
  {text: "jobBoard.appointment.durations.30m", minutes: 30},
  {text: "jobBoard.appointment.durations.45m", minutes: 45},
  {text: "jobBoard.appointment.durations.1h", minutes: 60},
  {text: "jobBoard.appointment.durations.2h", minutes: 120},
  {text: "jobBoard.appointment.durations.3h", minutes: 180},
  {text: "jobBoard.appointment.durations.4h", minutes: 240},
  {text: "jobBoard.appointment.durations.5h", minutes: 300},
  ];
// if adding more types, make sure you synchronize with .NET in GFD.DB.TypeEnums
const appointments = [
  {text: "jobBoard.appointmentTypes.showRoom", value: "ShowRoom"},
  {text: "jobBoard.appointmentTypes.homeEstimate", value: "HomeEstimate"},
  {text: "jobBoard.appointmentTypes.template", value: "Template"},
  {text: "jobBoard.appointmentTypes.install", value: "Install"},
  {text: "jobBoard.appointmentTypes.layout", value: "Layout"},
  {text: "jobBoard.appointmentTypes.warranty", value: "Warranty"},
  {text: "jobBoard.appointmentTypes.additionalTrip", value: "AdditionalTrip"},
  {text: "jobBoard.appointmentTypes.quote", value: "Quote"},
];

class ScheduleEntry extends React.Component{
  constructor(props) {
    super(props);

    const {scheduleEntry} = this.props;
    let selectedDurationIndex = 0;
    let selectedAppointmentIndex = 0;
    let selectedAlertIndex = 1;
    let newTime = '9:00';
    let am = true;
    if (scheduleEntry) {
      const start = moment(scheduleEntry.startTime, 'YYYY-MM-DDTHH:mm:ss Z');
      const end = moment(scheduleEntry.endTime, 'YYYY-MM-DDTHH:mm:ss Z');
      newTime = start.format('hh:mm');
      am = start.hour() < 12;
      const duration = moment.duration(end.diff(start)).asMinutes();
      selectedDurationIndex = _.findIndex(durations, {'minutes': duration});
      selectedAppointmentIndex = _.findIndex(appointments, {value: scheduleEntry.appointmentType});
      const firstAlert = _.first(scheduleEntry.alerts);
      if (firstAlert) {
        selectedAlertIndex = _.findIndex(alerts, {'minutes': firstAlert.minutes});
      }
    }
    let visibleDate = moment();
    let selectedDate = this.props.selectedDate || moment();
    this.state = {
      am,
      newTime,
      durations: durations.map(d => d.text),
      alerts: alerts.map(a => a.text),
      appointments: appointments.map(_ => _.text),
      selectedDurationIndex,
      selectedAlertIndex,
      selectedAppointmentIndex,
      newLeadType: null,
      newJobStatus: null,
      jobStatuses: null,
      selectedTab: this.props.initialTab || Enums.TABS.PROFILE,
      isNotesEditorVisible: false,
      noteText: '',
      selectedDate,
      visibleDate,
      calendarDays: Helpers.createCalendarMonthDays(visibleDate, selectedDate),
      isCalendarVisible: false,
      AR: this.props.AR
    };
  }

  calendarPopupRootNode = null;

  componentDidMount() {
    this.calendarPopupRootNode = ReactDOM.findDOMNode(this.refs.popupCalendarRoot);
  }

  chooseAm = (choose) => {
    this.setState({am: choose});
  };

  onChangeTime = (ev) => {
    const {value} = ev.target;
    const m = value.match(timeRegex);
    if (m) {
      if (+m[1] <= 12 && +m[3] <= 59) {
        this.setState({newTime: value});
      }
    }
  };

  durationItemClick = (text, index) => {
    this.setState({selectedDurationIndex: index});
  };

  alertItemClick = (text, index) => {
    this.setState({selectedAlertIndex: index});
  };

  leadTypeItemClick = (text) => {
    this.setState({newLeadType: text});
  };

  jobStatusItemClick = (text) => {
    this.setState({newJobStatus: text});
  };

  appointmentItemClick = (text, index) => {
    this.setState({selectedAppointmentIndex: index});
  };

  getDataToSave = () => {
    const dataToSave = {
      date: getDatePart(this.state.selectedDate),
      time: this.state.newTime,
      alert: alerts[this.state.selectedAlertIndex].minutes,
      duration: durations[this.state.selectedDurationIndex].minutes,
      appointmentType: appointments[this.state.selectedAppointmentIndex].value,
      am: this.state.am,
      newJobStatus: getEnglishLeadType(this.state.newJobStatus),
      newLeadType: getEnglishLeadType(this.state.newLeadType)
    }
    console.log('dataToSave', dataToSave);
    return dataToSave
  };

  selectTab  = (selectedTab) => {
    this.setState({selectedTab});
  };

  showNotesEditor = (show) => {
    let text = this.state.noteText;
    if (show) {
      text = '';
    }
    this.setState({isNotesEditorVisible: show, noteText: text});
  };

  handleNoteChange = (e) => {
    const {value} = e.target;
    if (value.length > QUOTE_MAX_NOTE_LENGTH) {
      this.setState({noteText: value.substring(0, QUOTE_MAX_NOTE_LENGTH)});
      return;
    }

    this.setState({noteText: value});
  };

  expandNote = (note) => {
    note.isExpanded = !note.isExpanded;
    if (note.isExpanded) {
      _.forEach(this.props.notes, n => {
        if (note.noteId !== n.noteId) {
          n.isExpanded = false;
        }
      });
    }
    this.forceUpdate();
  };

  expandDocument = (document) => {
    document.isExpanded = !document.isExpanded;
    if (document.isExpanded) {
      _.forEach(this.props.documents, d => {
        if (d.documentId !== document.documentId) {
          d.isExpanded = false;
        }
      });
    }
    this.forceUpdate();
  };

  downloadDocument = (doc) => {
    let tempLink = document.createElement('a');
    tempLink.href = doc.downloadUrl;
    tempLink.setAttribute('download', doc.fileName);
    tempLink.setAttribute('target', '_blank');
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  };

  chooseDocument = () => {
    ReactDOM.findDOMNode(this.refs.fileLoader).click();
  };

  handleUploadFieldChange = (e) => {
    let files = null;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    if (!files || !files.length) {
      console.log("No Files selected");
      return;
    }

    const file = files[0];
    if (file.size > QUOTE_MAX_DOCUMENT_SIZE) {
      this.props.dispatch(popupActions.errorBox_Show({
        title: 'Error',
        text: `File too large. Max accepted file size is ${formatFileSize(QUOTE_MAX_DOCUMENT_SIZE)}`,
        rightButtonText: 'OK',
        isRightButtonVisible: true
      }));
      return;
    }

    if (!validateFileExtension(file.name, QUOTE_DOCUMENT_TYPES)) {
      this.props.dispatch(popupActions.errorBox_Show({
        title: 'Error',
        text: "*." + file.name.split('.').pop() + ` file type is not accepted.`,
        rightButtonText: 'OK',
        isRightButtonVisible: true
      }));
      return;
    }

    this.props.dispatch(calendarActions.uploadJobFile(file));
  };

  /**
   *
   * @param dayOfMonth {int}
   */
  selectCalendarDay = (dayOfMonth) => {
    const {visibleDate} = this.state;
    this.state.selectedDate.year(visibleDate.year()).month(visibleDate.month()).date(dayOfMonth);
    this.setState({
      isCalendarVisible: false,
      selectedDate: this.state.selectedDate,
      calendarDays: Helpers.createCalendarMonthDays(this.state.visibleDate, this.state.selectedDate)
    });
  };

  /**
   *
   * @param month {moment}
   */
  changeCalendarMonth = (month) => {
    this.setState({
      visibleDate: month,
      calendarDays: Helpers.createCalendarMonthDays(month, this.state.selectedDate)
    });
  };

  /**
   *
   * @param year {int}
   */
  changeCalendarYear = (year) => {
    this.state.visibleDate.year(year);
    this.setState({
      visibleDate: this.state.visibleDate,
      calendarDays: Helpers.createCalendarMonthDays(this.state.visibleDate, this.state.selectedDate)
    });
  };

  setCalendarVisibility = (e) => {
    Misc.ignoreDefault(e);
    const v = this.state.isCalendarVisible;
    this.setState({isCalendarVisible: !this.state.isCalendarVisible},
      () => {
        if (!v) {
          ReactDOM.findDOMNode(this.refs.popupCalendarRoot).focus();
        }
      });
  };

  handleCalendarPopoverOnBlur = (e) => {
    this.setState({isCalendarVisible: false});
  };

  showFeatureList = () => {
    window.open('/receipt/FeatureList?jobId=' + this.props.job.jobId);
  }

  isAmericanImport = () => {
    const {asCustomer, auth} = this.props;
    let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    return fabricatorId === 140460 // American Import hardcode
  }

  getDateCreated = (doc) => {
    // return moment(scheduleEntry.startTime, 'YYYY-MM-DDTHH:mm:ss Z')
    return moment(doc.created || null).format('MM/DD/YYYY hh:mm')
  }

  getExtension = (doc) => {
    if (doc.extension) {
      return _.toUpper(doc.extension)
    }
    if (doc.downloadUrl) {
      const splitted = doc.downloadUrl.split(".");
      if (splitted.length) {
        return splitted[splitted.length - 1]
      }
    }
    return null
  }

  getDocumentTranslateId = (doc) => {
    const {intl} = this.props;
    const responseName = _.replace(doc.fileName, doc.extension, '');
    if (responseName.includes("for Quote")) {
      const splitted = responseName.split("for Quote");
      if (responseName.includes("SQFT Image for Quote")) { // it can be Kitchen SQFT Image for Quote 345681 || Cuisine SQFT Image for Quote 345681
        return intl.formatMessage({id: 'schedulePopup.documents.docName.SqftImage'}) + (splitted[1] || ""); // quote num
      } else if (responseName.includes("SQFT Slab Calculator")) { // Kitchen SQFT Slab Calculator Image for Quote 345681
        return intl.formatMessage({id: 'schedulePopup.documents.docName.SqftSlabCalculator'}) + (splitted[1] || ""); // quote num
      } else if (responseName.includes("SQFT Slab Image")) { // Kitchen SQFT Slab Image for Quote 345681
        return intl.formatMessage({id: 'schedulePopup.documents.docName.SqftSlabImage'}) + (splitted[1] || ""); // quote num
      } else if (responseName.includes("SQFT Appliance Image")) { // Kitchen SQFT Appliance Image for Quote 345681
        return (splitted[0] || ""); // quote num
      }
    }
    return responseName
  }

  render = template;
}

function mapStateToProps(state) {
  const {calendar, auth, asCustomer} = state;
  let {job, entriesLoading} = calendar;
  job = job || _.find(state.jobBoard.jobs, {'active': true});
  const scheduleEntry = calendar.entry ? _.find(calendar.latestEntries, {'id': calendar.entry.id}) : null;
  let entryLastStatus = job.status;
  if (calendar.entry) {
    const {entry} = calendar.entry;
    entryLastStatus = entry.lastStatus;
  }
  let notes = [].concat(job.notes || []);
  _.forEach(notes, n => {
    n.isExpanded = false;
  });
  let documents = [].concat(job.documents || []);
  _.forEach(documents, d => {
    d.isExpanded = false;
  });

  let recordings = [].concat(job.recordings || []);

  let initialTab = null;
  if (calendar.isNotesDocumentsOnly) {
    initialTab = calendar.scheduleEntryShowType;
  }

  const {bathroomSubscription, kitchenSubscription} = auth;
  const subType = misc.monads.NN(bathroomSubscription, _ => _.type, '') ||
    misc.monads.NN(kitchenSubscription, _ => _.type, '');

  let kitchenImage = getVisualizerImage(documents) || Misc.contentBgImageUrl('temp/shutterstock_138521096.jpg');

  return {
    auth,
    asCustomer,
    job,
    scheduleEntry,
    selectedDate: state.calendar.selectedDate,
    kitchenImage,
    entryLastStatus,
    notes,
    documents,
    recordings,
    initialTab,
    isNotesDocumentsOnly: calendar.isNotesDocumentsOnly,
    AR: AccessRights.get(state),
    subscriptionType: subType,
    entriesLoading,
  }
}

function getVisualizerImage(documents) {
  if(documents != null) {
    for(let i = 0; i < documents.length; i++)
    {
      if(documents[i].fileName.includes('Visualizer Image'))
        return documents[i].downloadUrl;
    }
  }
  return null;
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    close: () => dispatch(calendarActions.showScheduleEntry(false)),
    saveChanges: data => dispatch(calendarActions.saveScheduleEntry(data)),
    saveNote: note => dispatch(calendarActions.saveJobNote(note))
  }
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ScheduleEntry)
);

